import { routes2 } from '@linqpal/models'
import { ICheckInvoiceIsPaid } from '@linqpal/models/src/dictionaries'

export const checkInvoiceIsPaid = async (
  invoiceId: string,
): Promise<ICheckInvoiceIsPaid | null> => {
  try {
    const { status, isPaid } = await routes2.invoice.checkInvoiceIsPaid({
      invoiceId,
    })
    return { status, isPaid }
  } catch (err) {
    console.error(err)
    return null
  }
}
